import {DistanceProps} from 'modules/cities/types';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import companiesKeys from '../util/companies-keys';

const useCreateCompanyDistance = (companyId: string) => {
  const {create} = useQueryHelpers();

  const onSuccess = (data: DistanceProps) =>
    create(companiesKeys.distances(companyId), data);

  return useApiMutation<DistanceProps>({
    url: '/distances',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar distância',
    successTitle: 'Distância da empresa',
    successMessage: 'Distância cadastrada com sucesso',
    redirectUrl: `/settings/companies/${companyId}/distances`,
    onSuccess,
  });
};

export default useCreateCompanyDistance;
